<ion-button
  [disabled]="isDisabled"
  [fill]="fill"
  [color]="color"
  [size]="size"
  [expand]="expand"
  [type]="type"
  [attr.aria-label]="ariaLabel"
  [attr.data-testid]="testId"
  (click)="handleClick($event)"
>
  <ion-spinner
    *ngIf="loading; else buttonContent"
    class="button-spinner"
    name="dots"
    [attr.aria-label]="loadingAriaLabel"
  ></ion-spinner>
  <ng-template #buttonContent>
    <ng-content></ng-content>
  </ng-template>
</ion-button>
